module.exports = __webpack_public_path__ + "img/logo_live.3bd73d73.png";